import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import PartnerPublicDataSearch from '@/src/javascripts/partner/public_data/PartnerPublicDataSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const partnerPublicDataIndex = document.querySelector('#partner-public-data-index')
  if (partnerPublicDataIndex && !partnerPublicDataIndex.__vue_app__) {
    createApp({ components: { BaseAlert, PartnerPublicDataSearch } }).mount(partnerPublicDataIndex)
  }
})
